import { useMemo, useState } from 'react';

import { useConfig } from '~extension/icon-library/context/Config';
import { Box } from './Box';
import { DownloadPng } from './DownloadPng';
import { DownloadSvg } from './DownloadSvg';
import { DownloadVar } from './DownloadVar';

type DownloadProps = { icon?: Icon };
export const Download = ({ icon }: DownloadProps) => {
  const { pngOutputSizes } = useConfig();
  const formats = useMemo(() => {
    const availableFormats = ['SVG'];
    // PNG is only available if pngOutputSizes are defined and are not set to '0'
    if (pngOutputSizes && pngOutputSizes.length >= 1 && !pngOutputSizes.startsWith('0')) {
      availableFormats.push('PNG');
    }
    if (icon?.variations && Array.isArray(icon.variations) && icon.variations.length > 0) {
      availableFormats.push('VAR');
    }
    return availableFormats;
  }, [icon, pngOutputSizes]);
  const [selectedFormat, setSelectedFormat] = useState(formats[0]);

  if (icon) {
    return (
      <Box title="Download">
        <div>
          <div className={`border-gray border-solid border-0 border-b flex items-center justify-between`}>
            <div className={`box-border flex items-center opacity-50 px-2 text-left select-none py-2`}>Format</div>
            <div className={`flex`}>
              {formats.map(format => (
                <div
                  className={`cursor-pointer inline-block leading-none m-1 py-1 px-2 transition-all border-solid border ${
                    format === selectedFormat ? 'border-black' : 'border-gray'
                  }`}
                  key={format}
                  onClick={() => setSelectedFormat(format)}
                >
                  <span>{format === 'VAR' ? '...' : format}</span>
                </div>
              ))}
            </div>
          </div>
          {selectedFormat === 'SVG' && <DownloadSvg icon={icon} />}
          {selectedFormat === 'PNG' && <DownloadPng icon={icon} />}
          {selectedFormat === 'VAR' && <DownloadVar icon={icon} />}
        </div>
      </Box>
    );
  }
  return null;
};
